export var VideoPlaybackDelta;
(function (VideoPlaybackDelta) {
    /**
     * Type of delta event.
     */
    let type;
    (function (type) {
        type["VIDEO_PLAYBACK_DELTA"] = "video_playback_delta";
    })(type = VideoPlaybackDelta.type || (VideoPlaybackDelta.type = {}));
    /**
     * Video alignment setting.
     */
    let alignment;
    (function (alignment) {
        alignment["LEFT"] = "left";
        alignment["CENTER"] = "center";
        alignment["RIGHT"] = "right";
    })(alignment = VideoPlaybackDelta.alignment || (VideoPlaybackDelta.alignment = {}));
})(VideoPlaybackDelta || (VideoPlaybackDelta = {}));
